import { PlayerService } from '@modules/player/player-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import ManageModel from '@shared/manage/manage-model';

export default {
    namespaced: true,

    state: {
        findLoading: false,
        saveLoading: false,
        record: null,
    },

    getters: {
        record: (state) => state.record,
        findLoading: (state) => !!state.findLoading,
        saveLoading: (state) => !!state.saveLoading,
    },

    mutations: {
        RESET(state) {
            state.findLoading = false;
            state.saveLoading = false;
            state.record = null;
        },

        FIND_STARTED(state) {
            state.record = null;
            state.findLoading = true;
        },

        FIND_SUCCESS(state, payload) {
            state.record = payload;
            state.findLoading = false;
        },

        FIND_ERROR(state) {
            state.record = null;
            state.findLoading = false;
        },

        CREATE_STARTED(state) {
            state.saveLoading = true;
        },

        CREATE_SUCCESS(state) {
            state.saveLoading = false;
        },

        CREATE_ERROR(state) {
            state.saveLoading = false;
        },

        UPDATE_STARTED(state) {
            state.saveLoading = true;
        },

        UPDATE_SUCCESS(state) {
            state.saveLoading = false;
        },

        UPDATE_ERROR(state) {
            state.saveLoading = false;
        },
    },

    actions: {
        doNew({ commit }) {
            commit('RESET');
        },

        async doGetNewId(context, manage) {
            const manageInput = new ManageModel(manage).getManageModel()
            return await PlayerService.newId(manageInput)
        },

        async doFind({ commit, rootGetters }, id) {
            try {
                commit('FIND_STARTED');

                const currentManage = rootGetters['auth/manage/currentManage'];
                const manageInput = new ManageModel(currentManage).getManageModel()
                const record = await PlayerService.find(id, manageInput);

                commit('FIND_SUCCESS', record);
            } catch (error) {
                Errors.handle(error);
                commit('FIND_ERROR');
                routerAsync().push('/player');
            }
        },

        // async doCreate({ commit, rootGetters }, values) {
        //   try {
        //     commit('CREATE_STARTED');

        //     const currentManage = rootGetters['auth/manage/currentManage'];
        //     const manageInput = new ManageModel(currentManage).getManageModel();

        //     await PlayerService.create(values, manageInput);

        //     commit('CREATE_SUCCESS');
        //     Message.success(i18n('entities.player.create.success'));
        //     routerAsync().push('/player');
        //   } catch (error) {
        //     Errors.handle(error);
        //     commit('CREATE_ERROR');
        //   }
        // },

        async doCreate({ commit }, { id, values, manage }) {
            try {
                commit('CREATE_STARTED');
                await PlayerService.create(id, values, manage);

                commit('CREATE_SUCCESS');
                Message.success(i18n('entities.player.create.success'));
                //routerAsync().push('/player');
                routerAsync().go(-1);
            } catch (error) {
                Errors.handle(error);
                commit('CREATE_ERROR');
            }
        },

        async doUpdate({ commit }, { id, values, manage }) {
            try {
                commit('UPDATE_STARTED');
                await PlayerService.update(id, values, manage);

                commit('UPDATE_SUCCESS');
                Message.success(i18n('entities.player.update.success'));
                //routerAsync().push('/player');
                routerAsync().go(-1);
            } catch (error) {
                Errors.handle(error);
                commit('UPDATE_ERROR');
            }
        },

        async doUpdateTeams({ commit }, { id, subpropertyId, teams }) {
            try {
                commit('UPDATE_STARTED');
                await PlayerService.updateTeams(id, subpropertyId, teams);

                commit('UPDATE_SUCCESS');
                Message.success(i18n('entities.player.update.success'));
                //routerAsync().push('/player');
            } catch (error) {
                Errors.handle(error);
                commit('UPDATE_ERROR');
            }
        },
    },
};